import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import cow from "./../../assets/images/cow.svg"
import logo from "./../../assets/images/nextgen-logo.png"
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// actions
import { loginUser, apiError } from "../../store/actions"

// import images
import logoLightPng from "../../assets/images/logo-light.png"
import logoDark from "../../assets/images/logo-dark.png"

const Login = props => {
  const userData = localStorage.getItem("authUser")
  const userInfo = JSON.parse(userData)
  useEffect(() => {
    if (userInfo) {
      props.history.push("/dashboard")
    }
  }, [])

  // handleValidSubmit
  const handleValidSubmit = async (event, values) => {
    props.loginUser(values, props.history)
  }
  return (
    <React.Fragment>
      {!userInfo ? (
        <>
          <MetaTags>
            <title>Nextgen Dairy Admin Login</title>
          </MetaTags>
          <Row
            className=""
            style={{
              width: "100%",
              height: "100vh",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Col md={8} lg={8} xl={8} className="d-none d-sm-inline-block">
              <img
                src={cow}
                style={{
                  width: "100%",
                  height: "60vh",
                  display: "block",
                  margin: "auto",
                }}
              />
            </Col>
            <Col
              md={4}
              lg={4}
              xl={4}
              style={{
                height: "100vh",
                background: "#fff",
                boxShadow:
                  "0 -3px 31px 0 rgba(0,0,0,.05),0 6px 20px 0 rgba(0,0,0,.02)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h3 className="text-center">
                <Link to="/" className="d-block auth-logo">
                  <img
                    src={logo}
                    alt=""
                    style={{ maxWidth: "150px", height: "auto" }}
                    className="auth-logo-dark"
                  />
                  <img
                    src={logo}
                    alt=""
                    style={{ maxWidth: "150px", height: "auto" }}
                    height="60"
                    className="auth-logo-light"
                  />
                </Link>
              </h3>
              <div className="test">
                <div className="p-3">
                  <h4 className="text-muted font-size-18 mb-1 text-center">
                    Sign in
                  </h4>
                  <AvForm
                    style={{ position: "relative" }}
                    className="form-horizontal mt-4"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    {props.error && typeof props.error === "string" ? (
                      <Alert color="danger">{props.error}</Alert>
                    ) : null}

                    <div className="mb-3">
                      <AvField
                        name="email"
                        label="Email"
                        value=""
                        className="form-control"
                        placeholder="Enter email"
                        type="email"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <AvField
                        name="password"
                        label="Password"
                        value=""
                        type="password"
                        required
                        placeholder="Enter Password"
                      />
                    </div>

                    <div className="mb-3 row mt-4">
                      <div className="col-6">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Remember me
                          </label>
                        </div>
                      </div>
                      <div className="col-6 text-end">
                        <button
                          className="btn btn-primary w-md waves-effect waves-light"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>
                    </div>
                    <div className="form-group mb-0 row">
                      <div className="col-12 mt-4">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock"></i> Forgot your password?
                        </Link>
                      </div>
                    </div>
                  </AvForm>
                </div>
              </div>
              <div className="mt-5 text-center">
                <p>© {new Date().getFullYear()} All Rights Reserved</p>
              </div>
            </Col>
          </Row>
        </>
      ) : null}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default connect(mapStateToProps, { loginUser, apiError })(Login)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
}
